import { Tabs, TabsContent, TabsList, TabsTrigger } from 'base/src/components/Tabs/index';
import { PageBanner } from 'base/src/components/PageBanner';

import * as S from './styles';
import TabPagamento from './tabs/pagamento/TabPagamento';

function Configuracoes() {
  return (
    <S.Container>
      <PageBanner title='Resgate' subtile='Histórico de resgates' />
      <Tabs>
        <TabsList>
          <TabsTrigger value='tab1'>Teste</TabsTrigger>
          <TabsTrigger value='tab2'>Sza</TabsTrigger>
          <TabsTrigger value='tab3'>Pagamento</TabsTrigger>
          <TabsTrigger value='tab4'>GNX</TabsTrigger>
        </TabsList>
        <TabsContent value='tab1'>asdokasopdkaopskdaopksd</TabsContent>
        <TabsContent value='tab2'>AAAAAAAAAAAAAAAAA</TabsContent>
        <TabsContent value='tab3'>
          <TabPagamento />
        </TabsContent>
        <TabsContent value='tab4'>AAAAAAAAAAAAAAAAA</TabsContent>
      </Tabs>
    </S.Container>
  );
}

export default Configuracoes;